const ErrorPage = () => {
  return (
    <>
      Oops! An error occurred.
    </>
  );
}

export default ErrorPage;
